import { useCallback, useReducer } from "react";
function copyToClipboardReducer(_, action) {
  return action;
}
function getError(e) {
  return e instanceof Error ? e : new Error("unknown error");
}
const defaultConfig = {};
function useCopyToClipboard(config = defaultConfig) {
  const { onCopy, onDone, onError, onSuccess } = config;
  const [state, dispatch] = useReducer(copyToClipboardReducer, {
    value: "",
    isError: false
  });
  const copy = useCallback(
    async function copyToClipboard(text) {
      onCopy?.(text);
      if (!window.isSecureContext || !navigator?.clipboard) {
        dispatch({ value: "", isError: true, error: new Error("clipboard is not available") });
        return false;
      }
      try {
        await navigator.clipboard.writeText(text);
        dispatch({ value: text, isError: false });
        onSuccess?.(text);
        return true;
      } catch (e) {
        const error = getError(e);
        dispatch({ value: "", error, isError: true });
        onError?.(error);
        return false;
      } finally {
        onDone?.(text);
      }
    },
    [onCopy, onDone, onError, onSuccess]
  );
  return [state, copy];
}
export {
  useCopyToClipboard
};
//# sourceMappingURL=useCopyToClipboard.js.map
